module.exports = __webpack_public_path__ + "static/media/Off white.6ede66a0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/Off white.jpeg
// module id = 146
// module chunks = 0